module.exports = __webpack_public_path__ + "media/images/menu/lysithia-8ddd31057674cc4d8984f51912d2af4e.jpg";